$(function() {
   
    $("#brand_name").on("input tap", function(e){
        $(this).removeClass('is-invalid');
    });

    $(".example").click(function(){
        var platform = this.getAttribute('data-my-var'); 
        var video = $("."+ platform +"-video")[0];
        video.play();
        $("#"+ platform +"-sample-url-video").css("display", "flex");
    });

    $(".sample-url").click(function(){
        var platform = this.getAttribute('data-my-var');
        $("#"+ platform +"-sample-url-video").css("display", "none");
    });

    function isValidUrl(_string){
        // const matchPattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
        const matchPattern = /^(http(s):\/\/.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g;

        return matchPattern.test(_string);
    }

    function containsKeyword(url, keyword) {
        return url.toLowerCase().includes(keyword.toLowerCase());
    }

    function validateAndDisplayError(inputElement) {
        var value = inputElement.val().trim();
        var id = inputElement.attr('id');

        if (value !== '') {
            if (!isValidUrl(value)) {
                $('#error_' + id).html('Please provide a valid URL.');
                inputElement.addClass('is-invalid');
            } else {
                $('#error_' + id).html('');
                inputElement.removeClass('is-invalid');
            }

            if (id === 'fb_link' && !containsKeyword(value, 'facebook')) {
                $('#error_' + id).html('Please provide a Facebook URL.');
                inputElement.addClass('is-invalid');
            } else if (id === 'ig_link' && !containsKeyword(value, 'instagram')) {
                $('#error_' + id).html('Please provide an Instagram URL.');
                inputElement.addClass('is-invalid');
            } else if (id === 'tt_link' && !containsKeyword(value, 'tiktok')) {
                $('#error_' + id).html('Please provide a TikTok URL.');
                inputElement.addClass('is-invalid');
            } else {
                // Validate subdirectory only if platform keyword is correct
                try {
                    // Add a protocol if missing
                    if (!value.startsWith('http://') && !value.startsWith('https://')) {
                        value = 'http://' + value;
                    }
                    var url = new URL(value);
                    // Check for a subdirectory
                    if (!url.pathname || url.pathname === '/') {
                        $('#error_' + id).html('URL must include a subdirectory.');
                        inputElement.addClass('is-invalid');
                    } else {
                        $('#error_' + id).html(''); // Clear any previous error message
                        inputElement.removeClass('is-invalid');
                    }
                } catch (e) {
                    $('#error_' + id).html('Invalid URL format.');
                    inputElement.addClass('is-invalid');
                }
            }

            // Check for subdirectory in the URL
            // var url = new URL(value);
            // if (!url.pathname || url.pathname === '/') {
            //     $('#error_' + id).html('URL must include a subdirectory.');
            //     inputElement.addClass('is-invalid');
            // }
        } else {
            $('#error_' + id).html('');
            inputElement.removeClass('is-invalid');
        }
    }

    // Validate the value of any link when it changes
    $(".check_url").on("input", function(e) {
        var anyLinkHasValue = false;

        $(".check_url").each(function() {
            var value = $(this).val().trim();
            if (value !== '') {
                anyLinkHasValue = true;
                return false; // exit the loop early if any link has a value
            }
        });

        $(".check_url").each(function() {
            if (!anyLinkHasValue) {
                $(this).removeClass('is-invalid');
                $('#error_' + $(this).attr('id')).html('');
            } else {
                validateAndDisplayError($(this));
            }
        });
    });
});